import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: () => <span>Our wedding!</span>,
    [LANGUAGE.ZH]: () => <span>婚礼来啦！</span>,
}
